import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { Container, Row } from "reactstrap";
import DataReactTable from "@/containers/Tables/DataTable/components/DataReactTable";
import AddModal from "@/shared/components/AddModal";
import Modal from "@/shared/components/Modal";
import {
  useLazyGetRecordsQuery,
  useDeleteMutation,
} from "@/services/pcApi";
import { ROLE_TAG } from "@/shared/tagFile";
import { formateColumnFilter } from "@/utils/columnFilter";
import { successToast } from "@/shared/components/toast";
import RoleForm from "./RoleForm";
import { getAllRoles } from "../../AuthSlice";
import "react-toastify/dist/ReactToastify.css";

const Role = () => {
  const [roleDetails, setRoleDetails] = useState();
  const [isOpenAddModal, setIsOpenAddModal] = useState(false);
  const [isOpenDeleteModal, setIsOpenDeleteModal] = useState(false);
  const [selectedRecord, setSelectedRecord] = useState();
  const [deleteRole, { isLoading: isDeleting }] = useDeleteMutation();
  const [pageSize, setPageSize] = useState(10);
  const [page, setPage] = useState(1);
  const [sort, setSort] = useState([]);
  const [globalSearchKeyword, setGlobalSearchKeyword] = useState(null);
  const [columnFilter, setColumnFilter] = useState({});
  const dispatch = useDispatch();
  const [
    getRoleRecords,
    {
      data: roleList,
      isError: roleError,
      isLoading: roleLoading,
      isFetching: roleFetching,
    },
  ] = useLazyGetRecordsQuery();

  const column = [
    {
      Header: "#",
      accessor: "Id",
      type: "Number",
    },
    {
      Header: "User",
      accessor: "UserDTO.Name",
      filter: true,
      Cell: ({ value }) => {
        return value ? value : "-";
      },
    },
    {
      Header: "User Role",
      accessor: "RoleTypeDTO.Name",
      filter: true,
    },
  ];

  const handleSelectedRecord = (userData) => {
    setSelectedRecord(userData);
    setIsOpenAddModal(true);
  };

  const handleDelete = () => {
    deleteRole({
      entity: "Auth/Role",
      id: selectedRecord.Id,
      tag: ROLE_TAG,
    }).then((response) => {
      if (!response.error) {
        !isDeleting && setIsOpenDeleteModal(!isOpenDeleteModal);
        successToast("Role deleted successfully.");
      }
    });
  };

  useEffect(() => {
    let { filterColumn, filterQuery } = formateColumnFilter(
      column,
      columnFilter
    );

    getRoleRecords({
      entity: "Auth/Roles",
      top: pageSize,
      skip: (page - 1) * pageSize,
      sort: sort,
      filter: filterQuery,
      globalFilter: {
        columns: filterColumn,
        globalSearchKeyword: globalSearchKeyword,
      },
      entities: { RoleType: {}, User: {} },
      tag: ROLE_TAG,
    });
    setRoleDetails({ tableHeaderData: column, tableRowsData: [] });
    // eslint-disable-next-line
  }, [pageSize, page, sort, globalSearchKeyword, columnFilter]);

  useEffect(() => {
    if (!roleLoading && !roleError && roleList && !roleFetching) {
      dispatch(getAllRoles(roleList.value));
      let roleData = [...roleList.value];
      setRoleDetails({
        ...roleDetails,
        tableRowsData: roleList.value ? roleData : [],
        totalData:
          roleList && roleList["@odata.count"] ? roleList["@odata.count"] : 0,
        onEditClick: (data) => handleSelectedRecord(data),
        onDeleteClick: (data) => {
          setIsOpenDeleteModal(true);
          setSelectedRecord(data);
        },
      });
    }
    // eslint-disable-next-line
  }, [roleError, roleList, roleLoading, roleFetching]);

  return (
    <Container>
      <Row>
        {roleDetails && (
          <DataReactTable
            reactTableData={roleDetails}
            onAddClick={() => {
              setIsOpenAddModal(true);
              setSelectedRecord();
            }}
            title="Role"
            isFetching={roleFetching}
            setPageNumber={setPage}
            recordsPerPage={pageSize}
            setRecordsPerPage={setPageSize}
            setSort={setSort}
            setGlobalSearchKeyword={setGlobalSearchKeyword}
            setColumnFilter={setColumnFilter}
          />
        )}
      </Row>
      {isOpenAddModal && (
        <AddModal
          toggle={() => setIsOpenAddModal(false)}
          color="success"
          title={`${selectedRecord ? "Edit" : "Add"} Role`}
          header
          btn="Success"
          message={
            <RoleForm
              editData={selectedRecord ? selectedRecord : {}}
              setIsOpenAddModal={setIsOpenAddModal}
            />
          }
        />
      )}
      {isOpenDeleteModal && (
        <Modal
          color="danger"
          title="Delete"
          message={`Are you sure you want to delete ${selectedRecord.UserDTO.Name}?`}
          handleOkClick={() => handleDelete()}
          toggle={() => setIsOpenDeleteModal(!isOpenDeleteModal)}
          isDeleting={isDeleting}
        />
      )}
    </Container>
  );
};

export default Role;
